import React from 'react';
import RegistryMedicineOptionContent from './RegistryMedicineOptionContent';
import WarehouseMedicineOptionContent from './WarehouseMedicineOptionContent';
import {
  MedicineSearchOption,
  medicineOptionKey,
} from './medicineSearchOptions';

/** `renderOption` of both medicine pickers: a Warehouse or a registry row; typed text as itself. */
export function renderMedicineSearchOption(
  props: React.HTMLAttributes<HTMLLIElement>,
  option: MedicineSearchOption | string,
): React.ReactElement {
  if (typeof option === 'string') {
    return (
      <li {...props} key={option}>
        {option}
      </li>
    );
  }
  return (
    <li {...props} key={medicineOptionKey(option)}>
      {option.source === 'WAREHOUSE' ? (
        <WarehouseMedicineOptionContent option={option} />
      ) : (
        <RegistryMedicineOptionContent medicine={option.medicine} />
      )}
    </li>
  );
}
